import moment from "moment";
import Wage from "@/model/Wage";
import {WagePeriodV3Dto} from "@/service/EmployeeService";

export default {
  /**
   * Maps the wage periods of the v3 employee API onto {@link Wage}s, oldest first as the other functions expect
   * them - the v3 API returns them newest first.
   */
  fromWagePeriodsV3 (wagePeriods: Array<WagePeriodV3Dto>): Array<Wage> {
    return wagePeriods
      .map(wagePeriod => Object.assign(new Wage(), {
        uuid: wagePeriod.id,
        wage: wagePeriod.amount,
        wageType: wagePeriod.wageType,
        targetHours: wagePeriod.targetHours,
        validFrom: wagePeriod.validFrom,
        validTo: wagePeriod.validTo
      }))
      .reverse();
  },
  getCurrentWage (wages: Array<Wage>): Wage {
    const currentWage = wages.find(wage => {
      const validFromIsSameOrBeforeCurrentMonth = moment(wage.validFrom).isSameOrBefore(moment().startOf("month"));
      const validToIsSameOrAfterCurrentDay = !wage.validTo || moment(wage.validTo).isSameOrAfter(moment(), "day");
      return validFromIsSameOrBeforeCurrentMonth && validToIsSameOrAfterCurrentDay;
    });

    return Object.assign(new Wage(), currentWage) || new Wage();
  },
  // Wages are matched by their start date, as no two wages of an employee start on the same day and v3 wages have
  // no numeric id
  getNextWage (wages: Array<Wage>): Wage | null {
    const currentWage = this.getCurrentWage(wages);
    const indexCurrentWage = wages.findIndex(wage => wage.validFrom === currentWage.validFrom);
    if (wages.length > indexCurrentWage + 1) {
      return Object.assign(new Wage(), wages[indexCurrentWage + 1]);
    } else {
      return null;
    }
  },
  getFutureWages (wages: Array<Wage>): Array<Wage> {
    let futureWages = new Array<Wage>();
    const nextWage = this.getNextWage(wages);
    if (nextWage != null) {
      const indexNextWage = wages.findIndex(wage => wage.validFrom === nextWage.validFrom);
      if (wages.length > indexNextWage + 1) {
        futureWages = wages.slice(indexNextWage + 1);
      }
    }

    return futureWages;
  }
};
